module.exports = __webpack_public_path__ + "img/certificate.858069d8.svg";